import { Suspense, lazy } from 'react'
import { EventCountdownTimeDateContainer, Skeleton } from '@nv/components'
import BalletBox from '@nv/images/design/ballet-box-icon'
import { isAdmin } from '@nv/utils'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import styles from './AdminEventContent.module.scss'

const EventStatus = lazy(() => import('../event_status/EventStatus'))
const LazyNVButton = lazy(() => import('@nv/basic-components').then((module) => ({ default: module.NVButton })))

export const AdminEventContent = ({ event, title, votingOpen, onSelectEvent, loadingVotingOpen }: any) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  return (
    <div className={styles['container']}>
      <div className={styles['body']}>
        <div className={styles['content']}>
          <BalletBox />

          <div className={styles['title-container']}>
            <div
              className={clsx(styles['title-container__label'], {
                [styles['title-container__label--admin']]: isAdmin(),
              })}
            >
              {title[currentLanguage]}
            </div>

            <Suspense fallback={<div>Loading status...</div>}>
              {!loadingVotingOpen ? (
                <EventStatus hasVoted={false} votingOpen={votingOpen} eventState={event.state} />
              ) : (
                <Skeleton width={400} />
              )}
            </Suspense>

            <Suspense fallback={<div>Loading button...</div>}>
              <LazyNVButton
                text={t('main.details')}
                height={37}
                onClick={() => {
                  onSelectEvent(event)
                }}
              />
            </Suspense>
          </div>
        </div>

        <Suspense fallback={<div>Loading countdown...</div>}>
          {!loadingVotingOpen ? <EventCountdownTimeDateContainer event={event} votingOpen={votingOpen} /> : <Skeleton width={150} />}
        </Suspense>
      </div>
    </div>
  )
}
